<template>
  <div>
    <div class="results-summary">
        <ListCountResults
            :total-filtered-items="data.totalFilteredEvents"
            :total-items="data.totalEvents"
        />
        <span class="line"> | </span>
        <button class="style-label-underscore clear-filters-desktop" @click="$emit('reset-search-result')">Nulstil søgning</button>
    </div>
    <ul class="event-teaser event-list">
      <li class="event-list-item" v-for="item in data.events" :key="item.id">
        <a class="event-teaser-item" :href="item.url" data-position-related-container>
          <div class="event-teaser-date" data-position-related-button>
            <time class="event-teaser-day-month-wrapper" :datetime="item.date">
              <span class="event-teaser-day">{{ formatDay(item.date) }}</span>
              <span class="event-teaser-month">{{ formatMonth(item.date) }}</span>
            </time>
            <span v-if="item.timeFrom" class="event-teaser-time">
              <time>{{ item.timeFrom }}</time><template v-if="item.timeTo"> - <time>{{ item.timeTo }}</time></template>
            </span>
          </div>

          <div class="event-teaser-content">
            <h3 class="event-teaser-title style-h5">{{ item.title }}</h3>
            <div v-if="item.place" class="event-teaser-place">
              <span class="icon event-teaser-place-icon" aria-hidden="true" v-html="iconLocation"></span>
              <span>{{ item.place }}</span>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import ListCountResults from "../listCountResults.vue";
import { initHoverArrowAnimation } from '../../../layout-handlers.js'
import iconLocation from '../../../../images/icon-location.svg?raw'

// Props
const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

onMounted(async () => {
  initHoverArrowAnimation();
});

watch(() => props.data, async () => {
  initHoverArrowAnimation();
}, { flush: 'post' });

function formatDay(dateString) {
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return "";
  return String(date.getDate()).padStart(2, '0')
}

function formatMonth(dateString) {
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("da-DK", { month: "short" })
      .format(date)
      .replace(".", "")
      .toUpperCase()
}
</script>
